import { DownOutlined, UpOutlined } from "@ant-design/icons";
import PropTypes from "prop-types";

import SectionVerticalBar from "./SectionVerticalBar.jsx";
import { Question } from "./Question.jsx";
import BaseAccordion from "@/components_v2/Accordion/BaseAccordion.tsx";
import BaseTooltip from "@/components_v2/Tooltip/BaseTooltip.tsx";
import { useTranslation } from "react-i18next";

const SurveyViewDetails = ({
  sections,
  surveyStatisticsResponse,
  filteredQuestions = null,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <BaseAccordion
        defaultActiveKey={[]}
        expandIconPosition="start"
        expandIcon={({ isActive }) => (
          <>
            <BaseTooltip title={t("survey.labels.expandSurveySectionView")}>
              {isActive ? <DownOutlined /> : <UpOutlined />}
            </BaseTooltip>
          </>
        )}
        items={sections
          .slice()
          .sort((a, b) => a.index - b.index)
          .map((section) => {
            const questions = section.tabs.length
              ? section.tabs.reduce((acc, tab) => acc.concat(tab.questions), [])
              : section.questions;

            return {
              key: section.id,
              label: surveyStatisticsResponse.isSuccess && (
                <SectionVerticalBar
                  section={{
                    ...section,
                    statistics: surveyStatisticsResponse.data.find(
                      (i) => i.id === section.id,
                    ),
                  }}
                />
              ),
              children: (
                <div key={section.id} className="flex flex-col gap-300">
                  {questions
                    .filter(
                      (i) =>
                        filteredQuestions === null ||
                        filteredQuestions.includes(i),
                    )
                    .map((question, index) => (
                      <Question
                        key={question}
                        questionIndex={index}
                        questionId={question}
                      />
                    ))}
                </div>
              ),
            };
          })}
      />
    </>
  );
};

SurveyViewDetails.propTypes = {
  sections: PropTypes.array.isRequired,
  surveyStatisticsResponse: PropTypes.object.isRequired,
  filteredQuestions: PropTypes.array,
};

export default SurveyViewDetails;
